import styles from './DrWeb.module.css';
import drweb from './../PartnersLogo/DrWeb.png';

const DrWEB = () => {
   return (
      <div className="container-lg">
         <div className="row justify-content-start m-5">
            <div className="col">
               <header className={styles.header}>
                  <h6>Главная--Партнеры--Dr.WEB</h6>
                  <h1>Dr.WEB</h1>
               </header>
            </div>
         </div>

            <hr />

         <div className="row justify-content-start">

               <div className="col-lg-4 col-sm-12 justify-content-center">
                  <img className={styles.body} src={drweb} alt="actlogo" />
               </div>

                <div className="col-lg-8 col-sm-12 ">
                <div>
                  <h4>С 1992 года российский антивирус Dr.Web обеспечивает базовую потребность бизнеса — защиту цифровых активов предприятий, помогает им работать в безопасной цифровой среде.</h4>
                  <p>В экономике нет ни одной отрасли, которая могла бы бесперебойно функционировать без средств защиты информации от вирусозависимых компьютерных инцидентов (ВКИ) — то есть без антивируса.</p>
                  <p>Разработка Антивируса Dr.Web началась в первой половине 90-х годов ХХ века, когда Интернет только развивался и еще не стал «глобальной сетью», а позволить себе доступ к мировой сети могли лишь немногие предприятия.Dr.Web был на пике популярности почти с момента своего появления — в середине 90-х в России не было ни одного компьютера, на котором не был бы установлен Dr.Web. Этот качественный высокотехнологичный продукт более 25 лет существует на исключительно жестком, высококонкурентном рынке антивирусов.</p>
                  <p>Стратегической задачей компании, на которую нацелены усилия всех сотрудников, является создание лучших средств антивирусной защиты, отвечающих всем современным требованиям к этому классу программ, а также разработка новых технологических решений, позволяющих пользователям встречать во всеоружии любые виды компьютерных угроз.</p>
                  <p>Команда разработчиков «Доктор Веб» оперативно реагирует на требования рынка и постоянно предлагает компьютерному сообществу новые эффективные компоненты и приложения. Продуктовая линейка антивирусов, разрабатываемых и поставляемых компанией «Доктор Веб», охватывает широчайший спектр операционных систем и совместимых приложений.</p>
               </div>
                </div>
         </div>
      </div>
   )
}
export default DrWEB;